var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "chapter-list-item" }, [
    _c(
      "div",
      {
        staticClass: "chapter-list-item__chapter-info clickable",
        class: { "chapter-list-item__chapter-info--active": _vm.isActive },
        on: {
          click: function($event) {
            return _vm.selectChapter()
          }
        }
      },
      [
        _c("div", { staticClass: "chapter-list-item__chapter-description" }, [
          _c(
            "div",
            {
              staticClass:
                "chapter-list-item__chapter-title typography--caption"
            },
            [
              _vm._v(
                "\n        " +
                  _vm._s(
                    _vm.$t("series_cards.chapters.index", {
                      i: _vm.chapter.position
                    })
                  ) +
                  ": " +
                  _vm._s(_vm.chapter.name) +
                  "\n      "
              )
            ]
          )
        ])
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2f06b5c6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2f06b5c6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/publishers/components/ChapterListItem.vue
// module id = t/qG
// module chunks = 1